// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"79d058c6","274":"86e46596","276":"290eb335","488":"ccd1aab5","663":"983e9d65","761":"d1b07dfa","762":"c1c1d22d","788":"ce9b006c","972":"b2cd6a58","988":"174fbd69","997":"a4fe07f1"}[chunkId] + ".chunk.js";
};